module.exports = __webpack_public_path__ + "img/noshow_status.b8b5f4dc.svg";